import React from 'react';
import { Sparkles, Heart, Globe } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-yellow-50 via-pink-50 to-purple-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-pink-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_spanglish-hub/artifacts/clvtlre5_ChatGPT%20Image%20May%2012%2C%202026%2C%2009_55_24%20PM.png" 
                alt="Johana - Founder of Hola Spanglish"
                className="w-full h-[600px] object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-purple-300 rounded-full opacity-40 blur-3xl"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-pink-300 rounded-full opacity-40 blur-3xl"></div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <div>
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-200 to-purple-200 text-purple-700 px-4 py-2 rounded-full text-sm font-bold mb-4 border-2 border-purple-300">
                <Heart className="h-4 w-4" />
                Meet the Founder
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
                Hi! I'm Johana,
              </h2>
              <p className="text-lg md:text-xl text-purple-500 font-semibold">
                the heartbeat behind <span className="bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">Hola Spanglish</span>.
              </p>
            </div>

            <div className="prose prose-lg text-gray-700 leading-relaxed space-y-4">
              <p className="text-lg">
                My story started in Brooklyn, between coffee shops, cultural exchanges,
                and international friendships that still inspire me to travel the world.
              </p>

              <p className="text-lg">
                I created <span className="font-bold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">Hola Spanglish</span> because
                I wanted language learning to feel different — more real, more personal,
                and deeply connected to culture.
              </p>

              <p className="text-lg">
                Here, learning Spanish isn't just about grammar. It's about enjoying the
                process, building confidence, and feeling connected every step of the way.
              </p>

              <div className="bg-gradient-to-r from-purple-300 via-pink-300 to-blue-300 text-purple-800 p-6 rounded-3xl mt-8 border-3 border-purple-300 shadow-lg">
                <p className="text-xl font-bold mb-2 flex items-center gap-2">
                  <Sparkles className="h-6 w-6" />
                  Join us to learn together!
                </p>
                <p className="text-purple-700">
                  Discover Spanish from an authentic and fun perspective
                </p>
              </div>
            </div>

            {/* Additional info badges */}
            <div className="flex flex-wrap gap-4 pt-4">
              <div className="flex items-center gap-2 text-sm text-purple-600 bg-purple-100 px-4 py-2 rounded-full border-2 border-purple-300">
                <Globe className="h-5 w-5" />
                <span>From Brooklyn, NY</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-pink-600 bg-pink-100 px-4 py-2 rounded-full border-2 border-pink-300">
                <Heart className="h-5 w-5" />
                <span>Passionate about teaching</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
